/**
 * Fuente de salas cuando NO hay servidor configurado (`VITE_NETPLAY_URL` /
 * `VITE_REGION_ENDPOINTS` vacíos): ninguna.
 *
 * Aquí vivía un mock con cinco salas inventadas ("Sala de Diego", "Ranked EU",
 * "Solo pros"…) que servía para maquetar el lobby antes de que existiera el
 * servidor. Cumplió su función y se fue: una lista de salas falsas en la
 * aplicación es un señuelo — el jugador pulsa UNIRSE en una sala que no existe
 * y lo que recibe es un error. Sin backend, la respuesta honesta es "no hay
 * salas", y el lobby lo dice con esas palabras.
 */
import {
  RoomFilter,
  RoomListProvider,
  RoomListSnapshot,
  RegionPing,
  RegionId,
} from "./contract";

export class OfflineRoomListProvider implements RoomListProvider {
  async listRooms(_filter?: RoomFilter): Promise<RoomListSnapshot> {
    return { rooms: [], fetchedAt: Date.now(), ttlMs: 1000 };
  }

  /** Sin edges configurados no hay a quién medirle el ping. */
  async pingRegions(): Promise<RegionPing[]> {
    return [];
  }
}

/** Regiones disponibles para el selector de la UI. */
export const AVAILABLE_REGIONS: readonly RegionId[] = [
  "us-east", "us-west", "eu-west", "eu-central", "sa-east", "ap-south", "ap-southeast",
];
